/* eslint-disable class-methods-use-this */
import {UIGameLayout} from '../../../shared/scripts/ui_game/UIGameLayout'

export class UIWGameLayout extends UIGameLayout {
    getHelpSectionY(): number {
        return 0
    }

    getHelpSectionHeight(): number {
        return 0
    }

    getStateControllerHeight(): number {
        return 0
    }

    getStateControllerY(): number {
        return 0
    }

    getPlayersControllerHeight(): number {
        return 0
    }

    getPlayersControllerChildOffset(): number {
        return 0
    }

    getEmbargoControllerY(): number {
        return this.canvas.margin
    }
}

